import React, { Fragment, useEffect, useState } from 'react';
import Typography from "@material-ui/core/Typography";
import DeleteCancel from "../../../atoms/buttons/DeleteCancel";
import Dialog from "../../../atoms/dialog";
import { useHistory } from "react-router-dom";
import { handleSnackBar, invokeGetService, invokePostService, setFocusElement, setReRender, toggleBottomDrawer } from '../../../../store/global/actions';
import { useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';
import { findNestedTransactions, findTransactionEvents } from '../../../../utils/transactionUtils';


const RemoveClusterletAlert = ({ onClose, nodeId, onCompletion }) => {
    const currentUrl = window.location.href;
    const [slug, blueprintID, tag, transactionId] = currentUrl.split('/').slice(4);


    const history = useHistory();
    const dispatch = useDispatch();
    const [transaction, setTransaction] = useState(null);
    const [loading, setLoading] = useState(false);
    const [clusterletEvents, setClusterletEvents] = useState([]);
    const [nodes, setNodes] = useState([]);
    const [noDeletionAlert, setNoDeletionAlert]  = useState(false);

    const findClusterletEvents = ({nodeId, txnEvents}) => {
        const nodeAssociatedEvents = txnEvents?.filter(event => (event.src === nodeId || event.dst === nodeId));
        return nodeAssociatedEvents || [];
    }

    const findTransactionClusterlets = (transaction, clusterlets) => {
        const clusterletNodes = transaction?.clusterlets?.map(item => {
            const clusterletObj = clusterlets?.find(clst => clst?._id === item?.id);
            clusterletObj.order = item.order;
            return clusterletObj;
        }) ;
        
        return clusterletNodes?.sort((a,b) => a?.order - b?.order ) || []
    }


    useEffect(() => {
        setLoading(true);
        dispatch(invokeGetService('getTransactionAssociates', [transactionId]))
            .then((response) => {
                if (response.data?.transaction) {
                    setTransaction(response?.data?.transaction);
                    const transactionNodes = findTransactionClusterlets(response?.data?.transaction, response?.data?.allClusterlets)
                    setNodes(transactionNodes);

                    const nestedTransactions = findNestedTransactions({transactions: response?.data?.allTransaction || [], parent: response?.data?.transaction});
                    let nestedTxnEvents = [];
                    nestedTransactions?.forEach(txn => {
                        nestedTxnEvents = [...nestedTxnEvents, ...findTransactionEvents({transaction: txn, allEvents: response?.data?.allEvents})]
                    })
                    
                    setClusterletEvents(findClusterletEvents({nodeId, txnEvents: [...response?.data?.events, ...nestedTxnEvents], clusterlets: response?.data?.allClusterlets}));
                    if(transactionNodes?.length === 1) setNoDeletionAlert(true);
                    setLoading(false);
                } else if (response?.status === false && response?.code === 255 && response.transactionNotFound === true) {
                    history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
                    dispatch(toggleBottomDrawer());
                }
            })
            .catch(error => {
                console.error("Fetching transaction associates failed. ", error);
            })
    }, [nodeId]);


    

    const onRemoveClusterlet = async () => {
        setLoading(true);
        
        const updatedNodeSet = nodes?.filter(node => node?._id !== nodeId);
        console.log({updatedNodeSet});

        const editTransaction = {
            ...transaction,
            clusterlets: updatedNodeSet.map((node, key) => ({ id: node._id, order: key, category: node.category !== undefined ? node.category : 'userdefined' }))
        }

        console.log({editTransaction})

        dispatch(invokePostService('updateTransactionNodes', { nodes: editTransaction.clusterlets }, [transaction._id]))
            .then((response) => {
                if (response.data) {
                    dispatch(setReRender());
                    onClose();
                    dispatch(handleSnackBar({ open: true, message: `Clusteret removed from transaction`, severity: "success" }));
                } else if (response.code === 254) {
                } else if (response?.status === false && response?.code === 255 && response.transactionNotFound === true) {
                    history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
                    dispatch(setFocusElement(null));
                }
                setLoading(false);
            })
            .catch(error => {
                console.error(`Updating transaction nodes failed. ${error}`);
            })
        
        onClose();
    };

    return (
        <Dialog
            container_id={"remove_clusterlet_dialog"}
            title={"Remove clusterlet from transaction"}
            handleClose={() => onClose(false)}
            open={true}
            actions={
                <>
                    <DeleteCancel disableButton={loading || noDeletionAlert} onCancel={() => onClose(false)} onDelete={onRemoveClusterlet} content={"Remove"} />
                </>
            }
        >
            <Grid container>
            
                {/* Events alert */}
                {clusterletEvents?.length > 0 && <>
                    <Grid item xs={12}>
                        <Typography> {`The following associated events will be removed.`}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Fragment>
                            <br />
                            <ol>
                                {clusterletEvents?.map((item, index) =>
                                    <li key={index}>  {item.name} </li>
                                )}
                            </ol>
                        </Fragment>
                    </Grid>
                </>}

                {noDeletionAlert && 
                    <Grid item xs={12}>
                        <Typography> Minimum two nodes must be needed for a transaction </Typography>
                    </Grid>
                }


                {/*Cofirmation message  */}
                {!noDeletionAlert &&
                    <Grid item xs={12}>
                        <Typography> {`Are you sure you want to remove this clusterlet?`} </Typography>
                    </Grid>
                }

            </Grid>
        </Dialog>
  )
}

export default RemoveClusterletAlert